import { render, staticRenderFns } from "./moment.vue?vue&type=template&id=40a6e5b0&scoped=true&"
import script from "./moment.vue?vue&type=script&lang=js&"
export * from "./moment.vue?vue&type=script&lang=js&"
import style0 from "./moment.vue?vue&type=style&index=0&id=40a6e5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a6e5b0",
  null
  
)

export default component.exports